import { FC, useMemo } from 'react';
import { QuickSurveyQuestionBlock } from './QuickSurveyQuestionBlock';
import { QuickSurveyProps } from './quickSurvey.types';
import { useQuickSurvey } from './useQuickSurvey';

export const QuickSurvey: FC<QuickSurveyProps> = ({
  surveyId,
  questions,
  existingAnswers,
  defaultAnswerIndex = 0,
  onChange,
  dropdownThreshold,
  visibleQuestionKeys
}) => {
  const { mappedQuestions, getSelectedAnswerId, handleSelectAnswer } =
    useQuickSurvey({
      surveyId,
      questions,
      existingAnswers,
      defaultAnswerIndex,
      onChange
    });

  // Filter displayed questions if visibleQuestionKeys is provided
  // Note: All questions still have default answers generated by the hook
  const displayedQuestions = useMemo(() => {
    if (!visibleQuestionKeys || visibleQuestionKeys.length === 0) {
      return mappedQuestions;
    }
    return mappedQuestions.filter((q) => visibleQuestionKeys.includes(q.key));
  }, [mappedQuestions, visibleQuestionKeys]);

  if (displayedQuestions.length === 0) {
    return null;
  }

  return (
    <div className="space-y-3">
      {displayedQuestions.map((question) => (
        <QuickSurveyQuestionBlock
          key={question.id}
          question={question}
          selectedAnswerId={getSelectedAnswerId(question.id)}
          onSelect={(answer) => handleSelectAnswer(question.id, answer)}
          dropdownThreshold={dropdownThreshold}
        />
      ))}
    </div>
  );
};
